import { withKeys as _withKeys, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30f317a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["ToolTip", "disabled"]
const _hoisted_2 = {
  style: {"pointer-events":"none"},
  class: "P-Abs D-Flex Inset0 W-100 H-100"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"pointer-events":"none"},
  class: "M-Auto"
}, null, -1))
const _hoisted_4 = ["onKeydown", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "colorFourth"
}
const _hoisted_6 = { class: "CookiesInputPlaceholder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["CookiesInputHolder color2", [_ctx.Disabled ? 'Disabled' : '']]),
    ref: _ctx.Res,
    style: _normalizeStyle(_ctx.StyledOut)
  }, [
    _withDirectives(_createElementVNode("input", {
      ToolTip: _ctx.MEMRead(_ctx.Res),
      onKeypress: _cache[0] || (_cache[0] = _withKeys(($event: any) => (($event.target as any)?.blur()), ["enter"])),
      disabled: _ctx.Disabled,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.InputChanged())),
      onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.focused && _ctx.focused(...args))),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.DelayDefocus())),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.$store.state.CookiesMemory[_ctx.Res ? _ctx.Res : '']) = $event)),
      class: _normalizeClass([_ctx.ErrorData && 'ErrorBorder', "CookiesInputInside InputColor color2"]),
      style: _normalizeStyle(_ctx.Height !== '' ? `height: ${_ctx.Height}` : ''),
      type: "string",
      name: "Name",
      autocomplete: "off"
    }, null, 46, _hoisted_1), [
      [_vModelText, _ctx.$store.state.CookiesMemory[_ctx.Res ? _ctx.Res : '']]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.MEMRead(_ctx.Res) !== '')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.RemoveSelection && _ctx.RemoveSelection(...args))),
            class: "HoverUp",
            style: _normalizeStyle([{"pointer-events":"auto","width":"3em","margin":"auto 0","opacity":"0.8"}, _ctx.Disabled ? 'pointer-events: none;' : ''])
          }, [
            _createVNode(_component_CookiesIcon, {
              style: {"width":"2em","height":"2em"},
              ID: 'Removed'
            })
          ], 4))
        : _createCommentVNode("", true)
    ]),
    (_ctx.NameOnFocus && !_ctx.NewValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "CookiesInputSearch",
          style: _normalizeStyle([_ctx.StyleDirection])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Options, (element, i) => {
            return (_openBlock(), _createElementBlock("div", {
              tabindex: "0",
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.DelayDefocus())),
              onKeydown: ($event: any) => (_ctx.KeyPressed(element, i, $event)),
              ref_for: true,
              ref: _ctx.Res + '_' + i,
              key: (element as any, i),
              onClick: ($event: any) => (_ctx.SelectElement(element)),
              style: _normalizeStyle([_ctx.SearchInput(element), {height: _ctx.RowHeight}, _ctx.Options.length < 50 ? '' : {animation: 'none'}]),
              class: "CookiesInputSearchElement"
            }, [
              (_ctx.Icon !== '')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "ImageList",
                    style: _normalizeStyle([{backgroundImage: ('url(' + element[_ctx.Icon] +'), url(' + _ctx.DefautlImage +')')}, {width: _ctx.RowHeight}, {height: _ctx.RowHeight}])
                  }, null, 4))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SelectorsFixed, (name, Index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: (Index),
                  class: _normalizeClass([Index === 0 && 'F-Bold', "M-Auto W-100"]),
                  style: _normalizeStyle( _ctx.$store.getters.Direction === 'ltr' ? 'text-align:left; padding-left:1em;' : 'text-align:right; padding-right:1em;')
                }, [
                  (Index !== 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.NameHandler(name)) + ": ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(_ctx.DeepFetcher(element, name)), 1),
                  _createTextVNode(),
                  _createElementVNode("span", null, _toDisplayString(name.toString().toLowerCase().includes('cost') || name.toString().toLowerCase().includes('price') ? _ctx.PriceUnit : ''), 1)
                ], 6))
              }), 128))
            ], 44, _hoisted_4))
          }), 128))
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", {
        class: "M-Auto",
        style: _normalizeStyle((_ctx.MEMRead(_ctx.Res) === '' || !_ctx.MEMRead(_ctx.Res)) ? 'margin-inline-start: 1.25em;' : 'margin-inline-start: 0.9em; margin-top: 0.2em; font-size: 0.75em; filter: blur(0.6px)')
      }, _toDisplayString(_ctx.Name), 5)
    ])
  ], 6))
}